<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Invullen gegevens van de partner
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Welke gegevens zijn er nodig?</b><br/>
                Voor een juiste berekening en aanvraag van de toeslagen zijn de volgende egevens van de (eventuele)
                toeslagpartner:<br/>
                <li class="list">Burgerservicenummer</li>
                <li class="list">Geboortedatum</li>
                <li class="list">Inkomen gehele jaar<br/>
                    Het gaat hier om het toetsinkomen voor het gehele aanvraagjaar. Wat tot het toestinkomen behoort,
                    kun je
                    lezen bij de 'Toelichting' bij het onderdeel over de aanvrager.
                </li>
                <li class="list">Vermogen gehele jaar<br/>
                    Het gaat hier om het vermogen voor het gehele aanvraagjaar. Wat tot het toestinkomen behoort, kun je
                    lezen bij de 'Toelichting' bij het onderdeel over de aanvrager.
                </li>
                <div class="space10"></div>

                <b>Waarom 12x gegevens invullen?</b><br/>
                Het lijkt wellicht wat overbodig, maar er zijn veel situaties denkbaar dat er gedurende het jaar een
                wijziging optreedt in het wel of niet hebben van een toeslagpartner. Lees meer over deze situaties
                elders in deze toelichting. <br/>
                En omdat toeslagen in tegenstelling tot belastingaangiften per maand berekend en betaald worden, is het
                van belang de gegevens per maand in te vullen.
                <div class="space10"></div>
                Let op! Vul wel bij het inkomen en vermogen de jaargegevens invult. Dus het toetsingsinkomen voor een
                heel kalenderjaar en ook het toetsingsvermogen voor het hele kalenderjaar.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Samen toeslag als toeslagpartner
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Je krijgt samen toeslag als je toeslagpartners bent</b><br/>
                Dat betekent dat het inkomen van je toeslagpartner vanaf dat moment ook meetelt. Heeft je toeslagpartner
                vermogen? Dat telt ook mee. Maar word je na 1 januari toeslagpartners? Dan telt het vermogen dit jaar
                nog niet mee, maar pas vanaf 1 januari volgend jaar.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Wie is toeslagpartner
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Voor toeslagen hebben we het over een 'toeslagpartner'. Een toeslagpartner is iemand die meetelt voor de
                toeslagen. Dit betekent dat het inkomen en vermogen van je allebei meetelt voor de toeslag, en dat je de
                toeslag samen krijgt. Je toeslagpartner kan je echtgenoot of geregistreerd partner zijn, of iemand
                anders die op je adres staat ingeschreven. Je kunt maar 1 toeslagpartner hebben.
                <div class="space10"></div>

                <b>Echtgenoot of geregistreerd partner</b><br/>
                Als je een echtgenoot of geregistreerd partner hebt, dan is deze persoon je toeslagpartner.
                <div class="space10"></div>

                <b>Iemand die op je adres staat ingeschreven</b><br/>
                Ben je niet getrouwd en heb je geen geregistreerd partner? Dan kan iemand die op je adres
                staat ingeschreven je toeslagpartner zijn. Dit is het geval als voor je én deze persoon 1 van de
                volgende situaties geldt:
                <div class="space10"></div>

                <b>Overzicht situaties</b><br/>
                <li class="list">je hebt samen een samenlevingscontract afgesloten bij de notaris.</li>
                <li class="list">je hebt samen een kind. Of je of de persoon die op je adres staat
                    ingeschreven, heeft een kind van de ander erkend.
                </li>
                <li class="list">jij óf degene die op je adres staat ingeschreven, is partner voor de
                    pensioenregeling van de ander. Of je bent aangemeld als elkaars partner voor de
                    pensioenregeling.
                </li>
                <li class="list">je hebt samen een koopwoning en woont daar allebei.</li>
                <li class="list">jij of de persoon die op je adres staat ingeschreven heeft een kind dat
                    jonger is dan 18 jaar én dit kind staat ingeschreven op je adres.
                </li>
                In de volgende situaties ben je geen toeslagpartners van elkaar:<br/>
                - Deze persoon is een onderhuurder.<br/>
                - Deze persoon is een vluchteling uit Oekraïne en je bent dat niet.<br/>
                - Deze persoon is een au pair waarmee je een au pair-contract hebt.<br/>
                <li class="list">je was vorig jaar al toeslagpartners van elkaar.</li>
                <div class="space10"></div>

                <b>Je woont met meer mensen in een huis</b><br/>
                Je kunt maar 1 toeslagpartner hebben. Heb je bijvoorbeeld met de één een kind (situatie
                2) en met de ander een koopwoning (situatie 4)? Dan geldt de eerst mogelijke situatie
                uit het overzicht. Degene met wie je een kind hebt, is dus je toeslagpartner.
                <div class="space10"></div>

                Situatie 5 geldt alleen als er maar 1 andere volwassene en minimaal 1 minderjarig kind
                bij je woont. Staan er op het moment dat je toeslag aanvraagt meer dan 2 volwassenen op je adres
                ingeschreven? Dan heb je geen toeslagpartner. Behalve als je al toeslagpartners bent of wordt op basis
                van situatie 1 t/m 4 uit het overzicht.
                <div class="space10"></div>

                Voor de huurtoeslag kunnen mensen die níét je toeslagpartner zijn wél medebewoners zijn.
                <div class="space10"></div>

                <b>Je kind of ouder woont bij je</b><br/>
                Woon je samen met je kind, stiefkind of pleegkind? Of met je ouder of stiefouder?
                Vanaf 1 januari 2025 is dit verandert. Je kind of ouder is dan niet meer je toeslagpartner. Dit telt
                bijvoorbeeld ook voor je pleegkind of stiefouder.
                <div class="space10"></div>

                Je zorgtoeslag, kindgebonden budget of kinderopvangtoeslag berekenen de Belastingdienst alleen nog met
                jouw inkomen en
                vermogen. Voor de huurtoeslag doen ze dit niet. Dat komt omdat je kind of ouder blijft meetellen als
                medebewoner voor de huurtoeslag.
                <div class="space10"></div>

                Wie tellen als uw kind of ouder?<br/>
                <ul>
                    <li>je kind, stiefkind, pleegkind of adoptiekind</li>
                    <li>je ouder, stiefouder, pleegouder of adoptieouder</li>
                    <li>je schoonouder, schoondochter of schoonzoon</li>
                    <li>het kind van je voormalige toeslagpartner</li>
                    <li>de voormalige toeslagpartner van je ouder</li>
                    <li>de ouders van je voormalige toeslagpartner</li>
                    <li>de voormalige toeslagpartner van je kind</li>
                </ul>
                <div class="space10"></div>
                Tellen de Belastingdienst een kind of ouder toch nog als toeslagpartner?<br/>
                Helaas kan dat soms gebeuren. Dan is het niet bij hen bekend dat het om een kind of ouder gaat.
                Bijvoorbeeld bij een stiefkind of stiefouder. Bel dan zo snel mogelijk de BelastingTelefoon om dit aan
                ons door te geven. Dan kijken zij samen met je of je vanaf 2025 geen toeslagpartners meer bent.
                <div class="space10"></div>

                <b>Je woont samen met je broer, zus, grootouder of kleinkind</b><br/>
                Dan is deze persoon je toeslagpartner als 1 van de situaties uit het voorgaande
                overzicht geldt.
                <div class="space10"></div>

                <b>Postadres</b><br/>
                Als iemand niet bij je woont maar wel op je adres staat ingeschreven met een
                postadres, dan is deze persoon niet je toeslagpartner.
                <div class="space10"></div>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Vanaf welk moment telt iemand mee als toeslagpartner
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Je bent elkaars toeslagpartner vanaf de 1e van de maand nádat je situatie is veranderd. De situaties die
                vaak voorkomen staan hieronder.
                <div class="space10"></div>

                <b>Je gaat trouwen</b><br/>
                Je bent elkaars toeslagpartner vanaf de 1e van de maand na je trouwen. Of vanaf de trouwdag als dat de
                1e van de maand was. Voor de berekening van de huurtoeslag telt je partner pas mee als jullie staan
                ingeschreven op hetzelfde adres.
                <div class="space10"></div>

                <b>Je wordt geregistreerd partners</b><br/>
                Je bent elkaars toeslagpartner vanaf de 1e van de maand na de registratie. Of vanaf de registratiedatum
                als dat de 1e van de maand was. Voor de berekening van de huurtoeslag telt je partner pas mee als jullie
                staan ingeschreven op hetzelfde adres.
                <div class="space10"></div>

                <b>Je gaat samenwonen</b><br/>
                Heb je een samenlevingscontract laten opstellen bij de notaris? Je bent elkaars toeslagpartner vanaf het
                moment dat je het samenlevingscontract hebt getekend én je op hetzelfde adres woont. De ingangsdatum is
                dan de 1e van de maand na beide gebeurtenissen. Als deze op de 1e van de maand waren, dan is het die
                datum.<br/>
                Heb je geen samenlevingscontract? Misschien ben je dan niet elkaars toeslagpartner. Check je situatie
                met het <a
                    href="https://www.belastingdienst.nl/wps/wcm/connect/nl/toeslagen/content/hulpmiddel-heb-ik-een-toeslagpartner"
                    target="_blank">hulpmiddel</a> van de Belastingdienst.
                <div class="space10"></div>

                <b>Je koopt samen een huis</b><br/>
                Je bent elkaars toeslagpartner vanaf het moment dat ke het koopcontract hebt getekend én samen op het
                adres van de gekochte woning woont. De ingangsdatum is dan de 1e van de maand na beide gebeurtenissen.
                Als deze op de 1e van de maand waren, dan is het die datum.
                <div class="space10"></div>

                <b>Je hebt samen een kind gekregen</b><br/>
                Je bent elkaars toeslagpartner vanaf het moment dat je samen een kind hebt gekregen én op hetzelfde
                adres
                woont. De ingangsdatum is dan de 1e van de maand na beide gebeurtenissen. Als deze op de 1e van de maand
                waren, dan is het die datum.
                <div class="space10"></div>

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading9">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse9" aria-expanded="false" aria-controls="collapse9">
                Niet het hele jaar elkaars toeslagpartner? Let op verdelen box 3-vermogen!
            </button>
        </h2>
        <div id="collapse9" class="accordion-collapse collapse" aria-labelledby="heading9"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Bijvoorbeeld omdat jij en je partner uit elkaar zijn gegaan, zijn gaan samenwonen of omdat uw partner is
                overleden? Maar kies je er wél voor om fiscale partners te zijn en samen belastingaangifte te doen? Let
                er dan goed op hoe je in de belastingaangifte het box 3-vermogen over u beiden verdeelt. Zo zorg je
                ervoor dat je je huurtoeslag, zorgtoeslag of kindgebonden budget niet of minder terug hoeft te betalen.
                <div class="space10"></div>
                Lees meer bij <a
                    href="https://www.belastingdienst.nl/wps/wcm/connect/nl/toeslagen/content/vermogen-verdelen-belastingaangifte-toeslagen"
                    target="_blank">Vermogen verdelen als je maar een deel van het jaar een toeslagpartner hebt</a>.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Wat je moet regelen als je geen toeslagpartners meer bent
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">

                Als je gaat scheiden of uit elkaar gaat, dan ben je meestal geen toeslagpartners meer van elkaar. Wat je
                dan moet regelen, hangt af van of ie was getrouwd, een geregistreerd partner had of samenwoonde. Lees
                meer op deze <a
                    href="https://www.belastingdienst.nl/wps/wcm/connect/nl/toeslagen/content/wij-gaan-uit-elkaar"
                    target="_blank">website</a>
                van de Belastingdienst.
                <div class="space10"></div>

                Als je toeslagpartner is overleden, lees dan <a
                    href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/toeslagen/wijzigingen_doorgeven/welke_wijzigingen_moet_ik_doorgeven/gezin_en_huishouden/er-is-iemand-overleden"
                    target="_blank">hier</a> wat je moet regelen.
                <div class="space10"></div>
            </div>
        </div>
    </div>

</div>

